import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Auth } from "aws-amplify";
import { loginUser } from "../redux/action/auth";
import { hasPendingSkills, clearUrlParameters } from "../utils/skillsUtils";
import ReactGA4 from "react-ga4";

export const useAuthRedirect = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuthStateChange = async () => {
      try {
        const currentSession = await Auth.currentSession();
        if (currentSession) {
          // console.log(
          //   "Social login - user session found, dispatching login action"
          // );
          // Dispatch login action to Redux
          await dispatch(loginUser(currentSession));

          // Track successful social login
          ReactGA4.event("login_completed", { method: "social" });

          // Clear URL parameters after successful authentication
          clearUrlParameters();

          // Check if there are pending skills from External Redirect
          const hasSkillsFromRedirect = hasPendingSkills();
          const hasPendingSkillsFlag =
            sessionStorage.getItem("hasPendingSkillsFromRedirect") === "true";
          // console.log("Social login redirect logic:", {
          //   hasSkillsFromRedirect,
          //   hasPendingSkillsFlag,
          // });

          if (hasSkillsFromRedirect || hasPendingSkillsFlag) {
            // Clear the flag
            sessionStorage.removeItem("hasPendingSkillsFromRedirect");
            // Redirect to skill-relevance page to populate skills
            // console.log(
            //   "Social login - redirecting to skill-relevance with pending skills"
            // );
            navigate("/skill-relevance");
          } else {
            // Check if there's a redirect URL stored
            const redirectUrl = sessionStorage.getItem("redirectAfterLogin");
            // console.log("Social login redirect logic:", { redirectUrl });

            if (redirectUrl) {
              sessionStorage.removeItem("redirectAfterLogin");
              // console.log(
              //   "Social login - redirecting to stored URL:",
              //   redirectUrl
              // );
              navigate(redirectUrl);
            } else {
              // Default redirect to skill-relevance page
              // console.log(
              //   "Social login - redirecting to default URL: /skill-relevance"
              // );
              navigate("/skill-relevance");
            }
          }
        }
      } catch (error) {
        console.error("Error handling auth state change:", error);
        ReactGA4.event("login_failed", {
          method: "social",
          error_reason: "social_auth_error",
        });
      }
    };

    // Check if user came from social login
    const clickedSocialMediaLogin = sessionStorage.getItem(
      "clickedSocialMediaLogin"
    );
    // console.log("useAuthRedirect - checking for social login:", {
    //   clickedSocialMediaLogin,
    // });

    if (clickedSocialMediaLogin) {
      sessionStorage.removeItem("clickedSocialMediaLogin");
      // console.log(
      //   "useAuthRedirect - social login detected, handling auth state change"
      // );
      handleAuthStateChange();
    }
  }, [dispatch, navigate]);
};
